import React, { useEffect } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import {
  DriverBasicDetailsContainer,
  FieldHolder,
} from "../../../constants/assets/DriverDetailsContainers";
import ServicesListFields from "../../../constants/DeliveryDrivers/ServicesListFields.json";
import variables from "../../../constants/assets/variables";
import { FieldsContainer, Pill } from "../../../constants/assets/containers";
import BlankState from "../../Common/BlankState";
import DriverServicesEditDetails from "./DriverServicesEditDetails";
import DriverServicesChangeLogList from "../DriverServicesChangeLogList";
import DriverServiceChangeLog from "../../../constants/DriverServiceChangeLog/DriverServiceChangeLog.json";


const DriverServicesDetails = ({
  driverServicesDetails,
  getDriverServicesDetails,
  editState,
  getEligibleDriverServices,
  eligibleServices,
  saveState,
  setSaveState,
  updateDriverServicesDetails,
  driverServicesChangeLogs,
}) => {
  const { id } = useParams();

  const getFieldValue = (field, key) => {
    if (key.includes("enabled")) {
      return <Pill isFalse={!field[key]}>{field[key] ? "Yes" : "No"}</Pill>;
    } else return field[key];
  };

  useEffect(() => {
    if (driverServicesDetails.length === 0) {
      getDriverServicesDetails(id);
    }
    if (editState && Object.keys(eligibleServices).length === 0) {
      getEligibleDriverServices(id);
    }
  }, [editState]);

  return (
    <DriverServicesDetailsContainer>
      {editState ? (
        <DriverServicesEditDetails
          services={eligibleServices}
          saveState={saveState}
          setSaveState={setSaveState}
          updateDriverServicesDetails={updateDriverServicesDetails}
          getDriverServicesDetails={getDriverServicesDetails}
          driverId={id}
        />
      ) : (
        <FieldsContainer>
          <FieldHolder repeat={4} display="grid">
            {ServicesListFields.map((field, index) => {
              return <span key={index}>{field.name}</span>;
            })}
          </FieldHolder>
          {driverServicesDetails.length > 0 ? (
            driverServicesDetails.map((service, index) => {
              return (
                <FieldHeading repeat={4} display="grid">
                  {ServicesListFields.map((field, idx) => {
                    return (
                      <span key={index + idx}>
                        {getFieldValue(service, field.key)}
                      </span>
                    );
                  })}
                </FieldHeading>
              );
            })
          ) : (
            <BlankState message=" " />
          )}
          <DriverServicesChangeLogList
                changes={driverServicesChangeLogs}
                tableFields={DriverServiceChangeLog} />
        </FieldsContainer>
      )}
    </DriverServicesDetailsContainer>
  );
};

const DriverServicesDetailsContainer = styled(DriverBasicDetailsContainer)``;

const FieldHeading = styled(FieldHolder)`
  span {
    color: ${variables.black};
    word-break: break-all;
  }
`;

function mapStateToProps(state) {
  const { DeliveryDrivers } = state;
  return {
    driverServicesDetails: DeliveryDrivers.driverServices,
    driverServicesChangeLogs: DeliveryDrivers.driverServicesChangeLog,
    eligibleServices: DeliveryDrivers.eligibleServices,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverServicesDetails: bindActionCreators(
      DeliveryDriversActions.getDriverServicesDetails,
      dispatch
    ),
    getEligibleDriverServices: bindActionCreators(
      DeliveryDriversActions.getEligibleDriverServices,
      dispatch
    ),
    updateDriverServicesDetails: bindActionCreators(
      DeliveryDriversActions.updateDriverServicesDetails,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverServicesDetails);
